export default __webpack_public_path__ + "static/media/Thumbnail-3.96498f0e.svg";